import { IdleInterruptSource } from './interrupt-source';

/**
 * A class for expressing arguments to interrupt events.
 */
export class IdleInterruptArgs {
    constructor(public source: IdleInterruptSource, public innerArgs: any, public force = false) {}
}
